import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { FAIRE_DIRECT_RECURRING_MARKETPLACE_MODAL_VISIT_STARTED_THRESHOLD_MILLIS } from "@faire/web-api--source/indigofair/settings/FAIRE_DIRECT_RECURRING_MARKETPLACE_MODAL_VISIT_STARTED_THRESHOLD_MILLIS";
var DEFAULT_THRESHOLD_MILLIS = 2 * 60 * 1000;
export var useSettingFaireDirectRecurringMarketplaceModalVisitThreshold = function() {
    return useSetting(FAIRE_DIRECT_RECURRING_MARKETPLACE_MODAL_VISIT_STARTED_THRESHOLD_MILLIS, DEFAULT_THRESHOLD_MILLIS);
};
